/* istanbul ignore file */
import { useWasteUrl } from 'domain/shared/waste';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';

const WasteBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useWasteUrl();
  const wasteListLink = getListUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Waste" link={wasteListLink} />
      {children}
    </Breadcrumbs>
  );
};

export default WasteBreadcrumbs;
